import { defineStore } from 'pinia';
import type { MapBasemapMode } from '@gpx-spa/geo-domain';
import {
  readPersistedStoreState,
  writePersistedStoreState,
} from '@/stores/persistence/pinia-indexeddb';

let hydratedFromBrowserDb = false;

export const useMapBasemapModeStore = defineStore('mapBasemapMode', {
  state: () => ({
    basemapMode: 'streets' as MapBasemapMode,
  }),
  actions: {
    async hydrateFromBrowserDb() {
      if (hydratedFromBrowserDb) {
        return;
      }
      const payload = await readPersistedStoreState<{
        basemapMode: MapBasemapMode;
      }>(this.$id);
      if (payload?.basemapMode === 'streets' || payload?.basemapMode === 'satellite') {
        this.$patch(payload);
      }
      hydratedFromBrowserDb = true;
    },
    persistToBrowserDb() {
      void writePersistedStoreState(this.$id, {
        basemapMode: this.basemapMode,
      });
    },
    setBasemapMode(mode: MapBasemapMode) {
      if (mode !== 'streets' && mode !== 'satellite') {
        return;
      }
      this.basemapMode = mode;
      this.persistToBrowserDb();
    },
  },
});
